import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { DEFAULT_META } from '../../constants/meta';

import { DEFAULT_PAGINATION } from '../../constants/pagination';
import { TIMEOUT_API_NODEJS_REQUEST } from '../../constants/timeouts';
import {
  fetchGetAgencies,
  IGetAgenciesRequest,
  IGetAgenciesResponse200 as IRes200,
  IGetAgenciesResponse400 as IRes400,
  IGetAgenciesResponse,
} from '../../repositories/agent-catalog-search/v1/get-agencies';

export interface IGetAgenciesDeps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export const defaultData = {
  items: [],
  meta: DEFAULT_META,
  ...DEFAULT_PAGINATION,
};

export function getAgencies(deps: IGetAgenciesDeps, parameters: IGetAgenciesRequest): Promise<IGetAgenciesResponse> {
  const { httpApi, logger, config } = deps;

  const timeout = config.get<number>('timeoutApiNodejsRequest.value') || TIMEOUT_API_NODEJS_REQUEST;

  return fetchGetAgencies<IRes200, IRes400>({
    httpApi,
    parameters,
    config: {
      ecnhancersConfig: { timeout },
    },
  })
    .then(res => {
      if (res.statusCode === 200) {
        return res.response;
      }

      logger.warning('Bad request agent-catalog-search/v1/get-agencies');

      return defaultData;
    })
    .catch(error => {
      logger.error(error);

      return defaultData;
    });
}
